<template lang="pug">
validation-observer(ref='contactForm')
  form(@submit.prevent='onSubmit')
    .form-floating.mb-2
      validation-provider.form-floating.d-block.mb-2(
        v-slot='{ errors, valid }',
        rules='required',
        name='คำนำหน้า'
      )
        select#prefix.form-select(
          v-model='fields.prefix' 
          :class='{ "is-invalid": errors[0], "is-valid": valid }'
        )
          option(selected, value='' disabled) เลือกคำนำหน้า
          option(value='นาย') นาย
          option(value='นางสาว') นางสาว
        label(for='prefix') คำนำหน้า *

    .row.g-2
      .col
        validation-provider.form-floating.d-block.mb-2(
          v-slot='{ errors, valid }',
          rules='required',
          name='ชื่อจริง'
        )
          input#firstname.form-control(
            v-model='fields.firstname',
            type='text',
            :class='{ "is-invalid": errors[0], "is-valid": valid }',
            placeholder='ชื่อจริง'
          )
          label(for='firstname') ชื่อจริง *
          .invalid-feedback {{ errors[0] }}

      .col
        validation-provider.form-floating.d-block.mb-2(
          v-slot='{ errors, valid }',
          rules='required',
          name='นามสกุล'
          )
          .form-floating.mb-2
            input#lastname.form-control(
              v-model='fields.lastname',
              type='text',
              :class='{ "is-invalid": errors[0], "is-valid": valid }',
              placeholder='นามสกุล'
            )
            label(for='lastname') นามสกุล  *
            .invalid-feedback {{ errors[0] }}
    .row.g-2
      .col
        validation-provider.form-floating.d-block.mb-2(
          v-slot='{ errors, valid }',
          rules='required|numeric|min:9',
          name='เบอร์โทรศัพท์'
        )
          input#mobile.form-control(
            v-model='fields.mobile',
            type='tel',
            :class='{ "is-invalid": errors[0], "is-valid": valid }',
            placeholder='เบอร์โทรศัพท์'
          )
          label(for='mobile') เบอร์โทรศัพท์  *
          .invalid-feedback {{ errors[0] }}

      .col
        validation-provider.form-floating.d-block.mb-2(
          v-slot='{ errors, valid }',
          rules='required',
          name='อีเมล์'
        )
          input#email.form-control(
            v-model='fields.email',
            type='email',
            :class='{ "is-invalid": errors[0], "is-valid": valid }',
            placeholder='อีเมล์'
          )
          label(for='email') อีเมล์ *
          .invalid-feedback {{ errors[0] }}

    validation-provider.form-floating.d-block.mb-2(
      v-slot='{ errors, valid }',
      rules='required',
      name='เรื่อง'
    )
      select.form-select(
        v-model='fields.subject',
        aria-label='เรื่อง',
        :class='{ "is-invalid": errors[0], "is-valid": valid }'
      )
        option(selected, value='' disabled) เรื่อง *
        option(value='ต้องการซื้อรถกอล์ฟไฟฟ้า') ต้องการซื้อรถกอล์ฟไฟฟ้า
        option(value='ต้องการเช่ารถกอล์ฟไฟฟ้า ') ต้องการเช่ารถกอล์ฟไฟฟ้า
        option(value='เข้าชมสินค้าตัวจริง') เข้าชมสินค้าตัวจริง
        option(value='แจ้งปัญหาการใช้งาน ') แจ้งปัญหาการใช้งาน
        option(value='ซ่อมแซมด่วน ') ซ่อมแซมด่วน
        option(value='อื่นๆ') อื่นๆ

      label เรื่อง *

      .invalid-feedback {{ errors[0] }}

    .form-floating.mb-4
      textarea#message.form-control(
        v-model='fields.message',
        placeholder='ข้อความ',
        style='height: 100px'
      )
      label(for='message') ข้อความ

    p.text-right
      button.button.button-large(type='submit', :disabled='buttonLoading')
        span.spinner-border.spinner-border-sm(
          v-if='buttonLoading',
          role='status',
          aria-hidden='true'
        )
        //- span Loading..
        | Submit
</template>

<script>
import MoveTo from 'moveTo'
import axios from 'axios'
// import Modal from 'bootstrap/js/src/modal.js'
// import Checkark from '../components/Checkmark.vue'

export default {
  data: () => ({
    buttonLoading: false,
    fields: {
      firstname: '',
    },
  }),

  created() {
    this.resetForm()
  },

  methods: {
    resetForm() {
      this.fields = {
        prefix: '',
        subject: '',
      }
    },

    onSubmit() {
      this.buttonLoading = true
      const form = this.$refs.contactForm
      form.validate().then((success) => {
        if (!success) {
          setTimeout(() => {
            const errors = Object.entries(form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter((error) => error['value'].length)

            const to = form.refs[errors[0]['key']].$el
            to.scrollIntoView()
            this.buttonLoading = false
          }, 100)
          return
        } else {
          axios
            .post(`${UGO.api.url}v1/contact`, { ...this.fields, page: window.location.href })
            .then(({ status }) => {
              if (status) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: 'formSubmission',
                  formType: 'Contact us',
                  ...this.fields
                });

                window.location = UGO.thankyouurl
              }
            })
            .catch((error) => {
              console.log(error)
            })
            .then(() => {
              this.buttonLoading = false
            })
        }
      })
      // try {
      // } catch (error) {
      //   const errors = error.response.data.errors
      //   form.setErrors(errors)
      // } finally {
      // }
    },
  },
}
</script>

